import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = "abcdefghijklmnopqrstuvwxyz123456"; // 32 characters

export const encrypt = (val) => {
    const encrypted = CryptoJS.AES.encrypt(val, ENCRYPTION_KEY).toString();
    return encrypted;
};

export const decrypt = (encryptedVal) => {
    const bytes = CryptoJS.AES.decrypt(encryptedVal, ENCRYPTION_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
};

// export const decryptedEnv = {
//     awsProjectRegion: decrypt(process.env.REACT_APP_AWS_PROJECT_REGION),
//     identityPoolId: decrypt(process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID),
//     cognitoRegion: decrypt(process.env.REACT_APP_AWS_COGNITO_REGION),
//     accessKeyId: decrypt(process.env.REACT_APP_AWS_ACCESS_KEY_ID),
//     secretAccessKey: decrypt(process.env.REACT_APP_AWS_SECRET_ACCESS_KEY),
//     baseUrl: decrypt(process.env.REACT_APP_BASE_URL),
//     baseUrlClient: decrypt(process.env.REACT_APP_BASE_URL_CLIENT),
// };